import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TelegramStroke = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.052 2C6.501 2 2 6.5 2 12.052s4.5 10.053 10.052 10.053 10.053-4.5 10.053-10.053C22.105 6.501 17.605 2 12.052 2ZM3.5 12.052a8.552 8.552 0 1 1 17.105 0 8.552 8.552 0 0 1-17.105 0Zm8.955-2.321a408.21 408.21 0 0 0-4.996 2.152c-.405.161-.618.319-.637.473-.033.26.294.363.738.503l.188.06c.437.142 1.025.308 1.331.315.278.006.587-.109.93-.343 2.332-1.575 3.537-2.371 3.612-2.389.053-.012.127-.027.178.018.05.044.045.129.04.151-.033.138-1.314 1.33-1.978 1.946l-.056.052c-.177.165-.3.28-.327.307-.067.07-.136.136-.201.2-.407.391-.711.685.017 1.165.35.23.63.42.909.61v.001c.305.208.609.415 1.002.673.1.066.196.134.29.2.354.253.673.48 1.067.444.229-.02.465-.236.586-.878.283-1.517.841-4.804.97-6.158a1.51 1.51 0 0 0-.014-.337.36.36 0 0 0-.122-.232.564.564 0 0 0-.332-.1c-.322.006-.817.178-3.195 1.167Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default TelegramStroke;
